export default "__VITE_ASSET__YUY8sPK___"